<template>
  <Popper :title="$t('ui.generals.members_editors')" max-width="285" placement="bottom">
    <!-- trigger -->
    <template #popper-trigger>
      <AppButtonIcon class="card-users__editor-add" icon="far fa-user-edit" />
    </template>
    <!-- body -->
    <template #popper-content>
      <AppMembersSection
        :title="$t('ui.generals.members_current')"
        :users="currentUsers"
        @selected="removeUser"
      />
    </template>

    <!-- action -->
    <template #popper-action>
      <AppMembers @selected="addUser" />
    </template>
  </Popper>
</template>

<script>
// Utilities
import Authorization from 'Mixins/Authorization'
// Components
import Popper from 'Modules/Popper'
import AppButtonIcon from 'Ui/AppButtonIcon'
import AppMembersSection from 'Components/AppMembers/components/AppMembersSection'

export default {
  name: 'CardUsersEditor',

  components: {
    Popper,
    AppMembers: () => import('Components/AppMembers'),
    AppButtonIcon,
    AppMembersSection,
  },

  mixins: [Authorization],

  data() {
    return {
      // showMembers: true,
    }
  },

  methods: {
    // toggleMembers() {
    //   this.showMembers = !this.showMembers
    // },

    addUser(user) {
      if (!this.isEmployee && user.type === 'EMPLOYEE') return
      this.$emit('add-user', user)
    },

    removeUser(user) {
      if (!this.isEmployee && user.type === 'EMPLOYEE') return
      this.$emit('remove-user', user)
    },
  },

  computed: {
    currentUsers() {
      return this.$store.state.cards.currentCard.users
    },
  },
}
</script>

<style scoped>
.card-users__editor-add {
  font-size: 14px;
  border-radius: 50px;
  background-color: var(--c-secondary-400);
}

.card-users__editor-add:hover {
  background-color: var(--c-secondary-200);
}
</style>
